import 'moment/locale/pt-br';
import 'react-toastify/dist/ReactToastify.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import store from './store';
import { Loading } from './components';
import Router from './Router';
import './i18n.js';

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <Router />
      <Loading />
      <ToastContainer />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root'),
);
